import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';

async function LogoutMagasin() {
    const MagasinId = localStorage.getItem('MagasinId') || localStorage.getItem('CommercialId') || localStorage.getItem('ClientId') || '';
    
    const clearStorage = () => {
      localStorage.removeItem("MagasinId");
      localStorage.removeItem("MagasinName");
      localStorage.removeItem("ClientId");
      localStorage.removeItem("ClientName");
      localStorage.removeItem("roleName");
      localStorage.removeItem("magasin_connecte");
      localStorage.removeItem("CommercialId");
      localStorage.removeItem("CommercialName");
      localStorage.removeItem("remise");
      localStorage.removeItem("productsCommercial");
      localStorage.removeItem("VisiteurName");
      localStorage.removeItem("VisiteurTele");
      localStorage.removeItem("VisiteurId");
      localStorage.removeItem("VisiteurAdresse");
      localStorage.removeItem("adresse");
      localStorage.removeItem("magasin_id");
      localStorage.removeItem("SoldeCommercial");
      localStorage.removeItem("Tele");
      localStorage.removeItem("SoldeClient");
      localStorage.removeItem("idMagasinLiee");
      localStorage.removeItem("MagasinLieeName");
      


    };

    try {
      if (MagasinId) {
        await axios.get(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${MagasinId}/logout`);
      }
    } catch (e) {
      console.error("Logout backend call failed:", e);
    } finally {
      clearStorage();
    }
}

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    LogoutMagasin().then(() => {
      setTimeout(() => {
        navigate('/');
      }, 1500); // Wait 1.5 seconds so the user can see the message
    });
  }, [navigate]); 

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#FAFAFA' }}>
      <div style={{ width: '40px', height: '40px', border: '4px solid #f3f3f3', borderTop: '4px solid #F5A623', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
      <span style={{ marginTop: '16px', color: '#64748B', fontWeight: 600, fontFamily: 'Inter, sans-serif', fontSize: '1.1rem' }}>
        Vous avez été déconnecté...
      </span>
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

export default Logout;




